import React from 'react'
import _ from 'lodash/fp'

import Grid from '@material-ui/core/Grid'

import { Speedometer } from '../../components/Charts'

export const useElementWidth = (initialWidth) => {
  const [width, setWidth] = React.useState(initialWidth === undefined ? window.innerWidth : initialWidth)

  const f = React.useCallback(node => {
    if (node !== null) {
      setWidth(node.getBoundingClientRect().width)
    }
  })

  return [f, width]
}

const Stats = ({ gameDetails }) => {
  const gir = _.getOr(0, 'game.greensInRegulation', gameDetails)
  const fir = _.getOr(0, 'game.fairwaysInRegulation', gameDetails)
  const scr = _.getOr(0, 'game.scramblings', gameDetails)
  const holesWithPutts = _.flow(_.getOr([], 'game.putts'), _.filter(v => Boolean(v)), _.size)(gameDetails)
  const putts = _.flow(_.getOr([], 'game.putts'), _.filter(v => Boolean(v) && v <= 2), _.size)(gameDetails)
  const numHolesPlayed = _.flow(_.get('game.toCh'), _.size)(gameDetails)

  const [itemRef, itemWidth] = useElementWidth()
  const radius = itemWidth * 0.9

  return (
    <Grid container>
      <Grid ref={itemRef} item xs={6} md={3}>
        <Speedometer width={radius} label='FiR' total={numHolesPlayed} value={fir} />
      </Grid>
      <Grid item xs={6} md={3}>
        <Speedometer width={radius} label='GiR' total={numHolesPlayed} value={gir} />
      </Grid>
      <Grid item xs={6} md={3}>
        <Speedometer width={radius} label='Scr' total={numHolesPlayed - gir} value={scr} />
      </Grid>
      <Grid item xs={6} md={3}>
        <Speedometer width={radius} label='2Pt' total={holesWithPutts} value={putts} />
      </Grid>
    </Grid>
  )
}

export default Stats
